import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { docenteService } from '../services/docenteService';

/** Catálogo de profesores que ofrecen temas. */
export function useDocentesPublicos(q: string, superarea: string) {
  return useQuery({
    queryKey: ['docentes-publicos', q, superarea],
    queryFn: () => docenteService.list({ q: q || undefined, superarea: superarea || undefined }),
    // Al cambiar el filtro la lista no parpadea: se queda la anterior mientras llega.
    placeholderData: keepPreviousData,
  });
}

/** Ficha de un profesor (sus áreas agrupadas). */
export function useDocenteFicha(rut: number) {
  return useQuery({ queryKey: ['docente-ficha', rut], queryFn: () => docenteService.ficha(rut) });
}

/** Supercategorías: son pocas y no cambian, así que no se refrescan solas. */
export function useSuperAreas() {
  return useQuery({ queryKey: ['superareas'], queryFn: docenteService.superareas, staleTime: 10 * 60_000 });
}
